import { call, put } from 'redux-saga/effects';
import { api } from 'rp-auth';
import {
  loadUserAmendSuccess,
  loadUserAmendFailure,
} from '../actions/userInfo';

const { getUserAmend } = api;

export default function* ({ payload }, sessionInfo) {
  try {
    const userInfo = yield call(getUserAmend, payload, sessionInfo);
    yield put(loadUserAmendSuccess(userInfo));
    return userInfo;
  } catch (error) {
    yield put(loadUserAmendFailure(error));
    return null;
  }
}
